import styled, { css } from 'styled-components';

/* 메인 컨테이너 */
export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
`;

export const MainContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const TitleSection = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 32px;
`;

export const PageTitle = styled.div`
  align-self: stretch;
  color: var(--Label-Normal, #171719);
  font-size: 28px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 700;
  line-height: 38.02px;
  word-wrap: break-word;
  margin: 0;
`;

/* 필터 섹션 */
export const FilterSection = styled.div`
  align-self: stretch;
  justify-content: space-between;
  align-items: flex-start;
  display: flex;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
`;

export const FilterControls = styled.div`
  overflow: hidden;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;

  > div {
    justify-content: flex-start;
    align-items: center;
    display: flex;
  }

  > div > div {
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
    display: flex;
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

/* 드롭다운 */
export const Dropdown = styled.div`
  position: relative;
  overflow: hidden;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  margin-right: 20px;
`;

export const DropdownSelect = styled.select`
  padding: 7px 11px;
  padding-right: 35px;
  position: relative;
  border-radius: 10px;
  border: 1px solid var(--Line-Normal-Neutral, rgba(112, 115, 124, 0.16));
  background: white;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  color: var(--Label-Strong, black);
  font-size: 15px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 500;
  line-height: 22.01px;
  letter-spacing: 0.14px;
  word-wrap: break-word;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
  outline: none;

  &:focus {
    border-color: var(--Label-Strong, black);
  }
`;

export const DropdownButton = styled.button`
  padding: 7px 11px;
  padding-right: 35px;
  position: relative;
  border-radius: 10px;
  border: 1px solid var(--Line-Normal-Neutral, rgba(112, 115, 124, 0.16));
  background: white;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  color: var(--Label-Strong, black);
  font-size: 15px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 500;
  line-height: 22.01px;
  letter-spacing: 0.14px;
  word-wrap: break-word;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
  outline: none;
  text-align: left;

  &:focus {
    border-color: var(--Label-Strong, black);
  }
`;

export const DropdownIcon = styled.svg`
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--Label-Strong, black);
  pointer-events: none;
`;

/* 검색 박스 */
export const SearchBox = styled.div`
  width: 250px;
  height: 36px;
  padding: 8px;
  overflow: hidden;
  border-radius: 12px;
  outline: 1px solid var(--Line-Normal-Normal, rgba(112, 115, 124, 0.22));
  outline-offset: -1px;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: flex;
  background: white;

  > div {
    flex: 1;
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
    display: flex;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SearchIcon = styled.div`
  height: 16px;
  width: 16px;
  padding-left: 2px;
  padding-right: 2px;
  justify-content: center;
  align-items: center;
  display: flex;
  opacity: 0.28;
`;

export const SearchInput = styled.input`
  flex: 1;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  border: none;
  outline: none;
  background: transparent;
  color: var(--Label-Normal, #171719);
  font-size: 12px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 400;
  line-height: 16.01px;
  letter-spacing: 0.30px;
  word-wrap: break-word;

  &::placeholder {
    color: var(--Label-Assistive, rgba(55, 56, 60, 0.28));
    font-size: 12px;
    font-family: 'Pretendard Variable', sans-serif;
    font-weight: 400;
    line-height: 16.01px;
    letter-spacing: 0.30px;
    word-wrap: break-word;
  }
`;

/* 테이블 컨테이너 */
export const TableContainer = styled.div`
  width: 100%;
  align-self: stretch;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid var(--Line-Solid-Normal, #E1E2E4);
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  background: white;
`;

export const TableInner = styled.div<{ $minWidth?: string }>`
  width: 100%;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  ${({ $minWidth }) => $minWidth && `min-width: ${$minWidth};`}
`;

/* 테이블 헤더 */
export const TableHeaderWrapper = styled.div`
  width: fit-content;
  min-width: 100%;
  position: relative;
`;

export const TableHeaderBackground = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--Fill-Alternative, rgba(112, 115, 124, 0.05));
  backdrop-filter: blur(32px);
  border-bottom: 1px solid var(--Line-Normal-Neutral, rgba(112, 115, 124, 0.16));
`;

export const TableHeaderBg = styled.div`
  width: 100%;
  height: 100%;
`;

export const TableHeader = styled.div<{ $columns?: string; $gap?: string }>`
  width: fit-content;
  min-width: 100%;
  position: relative;
  display: ${({ $columns }) => ($columns ? 'grid' : 'flex')};
  align-items: center;
  padding: 16px 20px;
  ${({ $columns, $gap }) =>
    $columns && `grid-template-columns: ${$columns}; column-gap: ${$gap || '16px'};`}
`;

export const HeaderCell = styled.div<{ variant?: 'number' | 'title' | 'category' | 'date' | 'actions' }>`
  color: var(--Label-Neutral, rgba(46, 47, 51, 0.88));
  font-size: 13px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.25px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  overflow: hidden;
  min-width: 0;

  ${({ variant }) => variant === 'number' && css`width: 100px;`}
  ${({ variant }) => variant === 'title' && css`flex: 1; flex-shrink: 1;`}
  ${({ variant }) => variant === 'category' && css`width: 150px;`}
  ${({ variant }) => variant === 'date' && css`width: 150px;`}
  ${({ variant }) => variant === 'actions' && css``}
`;

export const HeaderCellContent = styled.div`
  width: 100%;
  min-width: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
`;

export const HeaderText = styled.div`
  color: var(--Label-Neutral, rgba(46, 47, 51, 0.88));
  font-size: 13px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.25px;
  word-wrap: break-word;
`;

/* 테이블 바디 */
export const TableBody = styled.div`
  width: 100%;
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
`;

export const TableRow = styled.div<{ $columns?: string; $gap?: string }>`
  width: fit-content;
  min-width: 100%;
  border-bottom: 1px solid var(--Line-Normal-Neutral, rgba(112, 115, 124, 0.16));
  display: ${({ $columns }) => ($columns ? 'grid' : 'flex')};
  align-items: center;
  padding: 16px 20px;
  ${({ $columns, $gap }) =>
    $columns && `grid-template-columns: ${$columns}; column-gap: ${$gap || '16px'};`}

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: rgba(112, 115, 124, 0.03);
  }
`;

export const TableCell = styled.div<{ variant?: 'number' | 'title' | 'category' | 'date' | 'actions' }>`
  color: var(--Label-Normal, #171719);
  font-size: 16px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.09px;
  flex-shrink: 0;
  overflow: hidden;
  min-width: 0;
  display: flex;
  align-items: center;

  ${({ variant }) => variant === 'number' && css`width: 100px;`}
  ${({ variant }) => variant === 'title' && css`flex: 1; flex-shrink: 1;`}
  ${({ variant }) => variant === 'category' && css`width: 150px;`}
  ${({ variant }) => variant === 'date' && css`width: 150px;`}
  ${({ variant }) => variant === 'actions' && css``}
`;

export const TableCellContent = styled.div`
  width: 100%;
  min-width: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
`;

export const CellText = styled.div`
  color: var(--Label-Normal, #171719);
  font-size: 16px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.09px;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const TitleText = styled(CellText)`
  cursor: pointer;
  color: var(--Label-Normal, #171719);
  text-decoration: none;

  &:hover {
    color: var(--Primary-Normal, #448181);
    text-decoration: underline;
  }
`;

/* 액션 버튼들 */
export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: nowrap;
`;

const ActionButtonBase = styled.button`
  padding: 7px 8px;
  border-radius: 8px;
  border: 1px solid var(--Line-Normal-Neutral, rgba(112, 115, 124, 0.16));
  background: white;
  cursor: pointer;
  font-size: 12px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 500;
  line-height: 16.01px;
  letter-spacing: 0.30px;
  transition: background-color 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: rgba(112, 115, 124, 0.05);
  }
`;

export const DeleteButton = styled(ActionButtonBase)`
  color: var(--Accent-Foreground-Red, #E52222);
`;

export const EditButton = styled(ActionButtonBase)`
  color: var(--Label-Normal, #171719);
`;

export const HideButton = styled(ActionButtonBase)`
  color: var(--Label-Normal, #171719);
`;

/* 페이지네이션 */
export const PaginationContainer = styled.div`
  align-self: stretch;
  padding: 16px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const PaginationWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Pagination = styled.div`
  height: 32px;
  min-height: 32px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export const PaginationInner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export const PaginationButton = styled.button<{ $active?: boolean; $disabled?: boolean }>`
  width: 20px;
  height: 30px;
  min-width: 20px;
  padding: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 6px;
  overflow: hidden;

  &:hover {
    background: rgba(112, 115, 124, 0.05);
  }

  ${({ $active }) => $active && css`
    background: rgba(23, 23, 25, 0.09);
  `}

  ${({ $disabled }) => $disabled && css`
    cursor: not-allowed;
    opacity: 0.5;
  `}
`;

export const PaginationButtonContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PaginationButtonInner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PaginationButtonText = styled.div<{ $active?: boolean; $disabled?: boolean }>`
  text-align: center;
  font-size: 15px;
  font-family: 'Pretendard Variable', sans-serif;
  line-height: 22.01px;
  letter-spacing: 0.14px;

  ${({ $active }) => $active && css`
    color: var(--Label-Strong, black);
    font-weight: 500;
  `}

  ${({ $active, $disabled }) => !$active && !$disabled && css`
    color: var(--Label-Neutral, rgba(46, 47, 51, 0.88));
    font-weight: 400;
  `}

  ${({ $disabled }) => $disabled && css`
    color: var(--Label-Disable, rgba(55, 56, 60, 0.16));
  `}
`;

/* 페이지 이동 입력 */
export const PageJumpContainer = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  @media (max-width: 768px) {
    position: relative;
    right: auto;
    margin-top: 16px;
  }
`;

export const PageJumpLabel = styled.span`
  text-align: center;
  color: var(--Label-Alternative, rgba(55, 56, 60, 0.61));
  font-size: 13px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.25px;
`;

export const PageJumpInputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PageJumpInputContainer = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  display: inline-flex;
`;

export const PageJumpInputContent = styled.div`
  flex: 1;
  justify-content: flex-start;
  align-items: center;
  display: flex;
`;

export const PageJumpInput = styled.input`
  flex: 1;
  padding-left: 6px;
  padding-right: 6px;
  padding-top: 4px;
  padding-bottom: 4px;
  position: relative;
  border-radius: 8px;
  border: 1px solid var(--Line-Normal-Neutral, rgba(112, 115, 124, 0.16));
  background: transparent;
  justify-content: center;
  align-items: center;
  gap: 6px;
  display: flex;
  text-align: center;
  color: var(--Label-Normal, #171719);
  font-size: 14px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 500;
  line-height: 20.01px;
  letter-spacing: 0.20px;
  word-wrap: break-word;
  outline: none;

  &:focus {
    border-color: #007bff;
  }
`;

/* 데이터 없음 */
export const NoData = styled.div`
  align-self: stretch;
  padding: 40px;
  text-align: center;
  color: var(--Label-Alternative, rgba(55, 56, 60, 0.61));
  font-size: 16px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
`;

/* 로딩 및 에러 */
export const Loading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 16px;
  color: var(--Label-Alternative, rgba(55, 56, 60, 0.61));
  font-family: 'Pretendard Variable', sans-serif;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 40px;
  text-align: center;
  color: var(--Accent-Foreground-Red, #E52222);
  font-size: 16px;
  font-family: 'Pretendard Variable', sans-serif;
`;

export const RetryButton = styled.button`
  padding: 8px 16px;
  background: var(--Primary-Normal, #448181);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-family: 'Pretendard Variable', sans-serif;
  cursor: pointer;

  &:hover {
    background: var(--Primary-Dark, #336666);
  }
`;

/* 모달 오버레이 */
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const DateModal = styled.div`
  width: 100%;
  padding-bottom: 24px;
  background: var(--Background-Elevated-Normal, white);
  overflow: hidden;
  border-radius: 12px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: inline-flex;
  max-width: 500px;
  max-height: 90vh;
`;

export const DeleteModal = styled.div`
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  padding: 32px 24px;
  text-align: center;
`;

export const ModalHeader = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
`;

export const ModalTitle = styled.h3`
  color: var(--Label-Strong, black);
  font-size: 20px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 600;
  line-height: 28px;
  word-wrap: break-word;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--Label-Alternative, rgba(55, 56, 60, 0.61));
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: var(--Label-Normal, #171719);
  }
`;

export const ModalContent = styled.div`
  align-self: stretch;
  padding-top: 32px;
  padding-bottom: 16px;
  padding-left: 24px;
  padding-right: 24px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  display: flex;
`;

export const DateInputGroup = styled.div`
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

export const DateLabel = styled.label`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  display: inline-flex;
  color: var(--Label-Neutral, rgba(46, 47, 51, 0.88));
  font-size: 14px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 600;
  line-height: 20.01px;
  letter-spacing: 0.20px;
  word-wrap: break-word;
`;

export const DateInput = styled.input`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  display: inline-flex;
  flex: 1 1 0;
  padding: 12px;
  position: relative;
  border-radius: 12px;
  border: 1px solid var(--Line-Normal-Neutral, rgba(112, 115, 124, 0.16));
  background: rgba(0, 0, 0, 0);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.03);
  justify-content: center;
  align-items: center;
  gap: 12px;
  display: flex;
  color: var(--Label-Normal, #171719);
  font-size: 16px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.09px;
  word-wrap: break-word;
  outline: none;

  &:focus {
    border-color: var(--Primary-Normal, #448181);
  }

  &::placeholder {
    color: var(--Label-Assistive, rgba(55, 56, 60, 0.28));
    font-size: 16px;
    font-family: 'Pretendard Variable', sans-serif;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.09px;
    word-wrap: break-word;
  }
`;

export const PresetButtons = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
`;

export const PresetButton = styled.button`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid var(--Line-Normal-Neutral, rgba(112, 115, 124, 0.16));
  border-radius: 6px;
  background: transparent;
  color: var(--Label-Normal, #171719);
  font-size: 12px;
  font-family: 'Pretendard Variable', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 0;

  &:hover {
    background: rgba(112, 115, 124, 0.05);
  }
`;

export const ModalActions = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;

  > div {
    align-self: stretch;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    display: flex;
  }

  > div > div {
    align-self: stretch;
    padding: 24px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 16px;
    display: flex;
  }

  > div > div > div {
    align-self: stretch;
    justify-content: center;
    align-items: center;
    gap: 12px;
    display: inline-flex;
  }
`;

export const CancelButton = styled.button`
  flex: 1 1 0;
  padding-left: 28px;
  padding-right: 28px;
  padding-top: 12px;
  padding-bottom: 12px;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  font-size: 16px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.09px;
  word-wrap: break-word;
  cursor: pointer;
  transition: all 0.2s ease;
  background: transparent;
  color: var(--Primary-Normal, #448181);
  border: 1px solid var(--Line-Normal-Neutral, rgba(112, 115, 124, 0.16));

  &:hover {
    background: rgba(68, 129, 129, 0.05);
  }

  &:disabled {
    color: var(--Label-Disable, rgba(55, 56, 60, 0.16));
    border-color: var(--Line-Normal-Neutral, rgba(112, 115, 124, 0.16));
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
  flex: 1 1 0;
  padding-left: 28px;
  padding-right: 28px;
  padding-top: 12px;
  padding-bottom: 12px;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  font-size: 16px;
  font-family: 'Pretendard Variable', sans-serif;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.09px;
  word-wrap: break-word;
  cursor: pointer;
  transition: all 0.2s ease;
  background: var(--Primary-Normal, #448181);
  color: white;
  border: none;

  &:hover {
    background: #3a6b6b;
  }

  &:disabled {
    background: var(--Label-Disable, rgba(55, 56, 60, 0.16));
    cursor: not-allowed;
  }
`;

/* 삭제 모달 전용 */
export const DeleteIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
  color: #ff9800;
`;

export const DeleteModalTitle = styled.h3`
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--Label-Normal, #171719);
  font-family: 'Pretendard Variable', sans-serif;
`;

export const DeleteWarning = styled.p`
  margin: 0 0 24px 0;
  font-size: 14px;
  color: var(--Label-Alternative, rgba(55, 56, 60, 0.61));
  line-height: 1.4;
  font-family: 'Pretendard Variable', sans-serif;
`;

export const DeleteForm = styled.div`
  margin-bottom: 24px;
  text-align: left;

  label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: var(--Label-Normal, #171719);
    margin-bottom: 8px;
    font-family: 'Pretendard Variable', sans-serif;
  }
`;

export const Optional = styled.span`
  font-weight: 400;
  color: var(--Label-Alternative, rgba(55, 56, 60, 0.61));
  font-size: 12px;
`;

export const ReasonTextarea = styled.textarea`
  width: 100%;
  height: 80px;
  padding: 12px;
  border: 1px solid var(--Line-Normal-Neutral, rgba(112, 115, 124, 0.16));
  border-radius: 8px;
  font-size: 14px;
  color: var(--Label-Normal, #171719);
  resize: vertical;
  font-family: 'Pretendard Variable', sans-serif;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: var(--Primary-Normal, #448181);
  }

  &::placeholder {
    color: var(--Label-Assistive, rgba(55, 56, 60, 0.28));
  }
`;

export const DeleteActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;
